// extracted by mini-css-extract-plugin
export default {"main__layout":"dashboard_main__layout__+-xFe","layout__body":"dashboard_layout__body__ziSJQ","layout__outlet":"dashboard_layout__outlet__-RZmp"};